//constants
import Vue from 'vue'
const axios = require("axios").default
const SNAPSIZE = 10;

var vue = new Vue({
  el: '#app',
  data() {return {
    basedir: "/mobile/manuals/products/viewer/",
    isMenuOpen: false,
    isNavOpen: true,
    isAcOpened: false,
    isTutorial: 0,
    pages: [],
    curArea: 0,
    pageX: 0,
    pageY: 0,
    pageWidth: 640,
    pageHeight: 900,
    areaWidth: 0,
    areaHeight: 0,
    maxViewerSize: 640,
    pageZoom: 1,
    isIframeEnable: false,
    viewerMode: '',
    isLoading: true,

    paramPage: "",
    uiZoomLevel: 0,
    tableOfContents: [],

    //PDF
    contents_name: "",
    areas:[],
    pages:[],
    pcAreas:[],
    spAreas:[],
    bookmarks:[],
    dirname: "",
    contents_name: "",
    parent_name: "",
    parent_link: "",
  }},
  created() {
    let _ft = localStorage.getItem('isViewerFirsttime');
    if(_ft === "false") {
      this.isTutorial = 2;
    }
    window.addEventListener('resize', () => {this.checkWindowSize();});
    this.checkWindowSize();
  },
  mounted() {
    //URLパース
    const keyname = this.basedir.replace(/^\//, '').replace(/\/$/, '').split('/').pop()
    const dirnames = location.pathname.replace(/^\//, '').replace(/\/$/, '').split('/');
    let dirname = "";
    let page = "";
    for (let i = 0; i < dirnames.length; i++) {
      if (dirnames[i] == keyname) {
        if (i + 2 == dirnames.length-1) {
          dirname = dirnames[i+1];
          page = dirnames[i+2];
        } else if (i + 1 == dirnames.length-1) {
          dirname = dirnames[i+1];
        }
      }
    }
    if (dirname == "") {
      //location.href = "/404.html"
      console.log("ERROR");
    }
    if (page == "") {
      page = "1-1";
    } else {
      const p = page.split("-");
      if (p.length != 2) {
        page = "1-1";
      } else if (isNaN(Number(p[0])) || isNaN(Number(p[1]))) {
        page = "1-1";
      } else if (Number(p[0]) < 1) {
        page = "1-1";
      } else if (Number(p[1]) < 1) {
        page = "1-1";
      }
    }
    this.paramPage = page;

    //URLからJSONロード
    this.curArea = 0;
    this.loadManual(dirname);
  },
  methods: {
    onClickTutorial() {
      this.isTutorial = this.isTutorial + 1;
      if(this.isTutorial > 1) {
        localStorage.setItem("isViewerFirsttime", 'false')
      }
    },

    checkWindowSize() {
      //PC SP切替時にページを引き継ぐ
      let nextMode = "pc";
      if (window.innerWidth < 640) {
        nextMode = "sp";
      }
      if (this.viewerMode && nextMode != this.viewerMode) {
        if (this.isIframeEnable) {
          const page = this.getCurrentAreaInfo().page;
          this.viewerMode = nextMode;
          const areas = this.getCurrentAreas();

          let nextArea = -1;
          areas.forEach( (a,idx)  => {
            if (nextArea < 0) {
              if (a.page == page) {
                nextArea = idx;
              }
            }
          })
          this.curArea = nextArea;

          this.loadPage(this.dirname, this.getCurrentAreaInfo().page);
        } else {
          this.viewerMode = nextMode;
        }
      } else {
        this.viewerMode = nextMode;
      }
    },

    loadManual(dirname) {
      this.contents_name = "";
      this.parent_name = "";
      this.parent_link = "";
      this.isIframeEnable = false;
      const tms = Math.floor((new Date()).getTime() / 1000 / 300);
      //URLからJSONロード
      axios.get(`/mobile/products/data/${dirname}/setting.json?r=${tms}`).then( res => {
        this.areas = res.data.areas;
        this.pages = res.data.pages;
        this.dirname = dirname;
        this.contents_name = res.data.contents_name;
        this.parent_name = res.data.parent_name;
        this.parent_link = res.data.parent_link;

        res.data.areas.forEach( (p, page) => {
          p.forEach( a => {
            if (a.type == "pc") {
              a.page = page;
              this.pcAreas.push(a);
            } else {
              a.page = page;
              this.spAreas.push(a);
            }
          })
        })

        //URLパラメータの値チェックと、ページ指定ロード
        const p = this.paramPage.split("-");
        let page    = Number(p[0]-1);
        let subpage = Number(p[1]);
        if (!(0 <= page && page < this.pages.length)) {
          page = 0;
        }
        const curareas = this.getCurrentAreas();
        this.curArea = 0;
        curareas.forEach( (a,idx) => {
          if (a.page == page && a.subPage == subpage) {
            this.curArea = idx;
          }
        });

        this.loadPage(this.dirname, page);
        this.makeTableOfContents();

      }).catch(e => {
        //location.href = "/404.html"
        console.log(e, "error ajax")
      })
    },
    loadPage(dirname, page) {
      this.isLoading = true;
      this.isIframeEnable = false;
      this.$refs.pdfiframe.src = `/manuals/${dirname}/${this.pages[page]}`;
      this.$refs.pdfiframe.onload = this.onLoadPage;
    },

    makeTableOfContents() {
      this.tableOfContents = [];
      let curGroup = "------";
      let curContents = null;
      
      this.pcAreas.forEach((a,idx) => {
        if (a.tocText) {
          let gname = typeof(a.tocGroup) == 'undefined' ? "" : a.tocGroup;
          if (curGroup != gname) {
            this.tableOfContents.push({
              tocGroup: gname,
              contents: [],
              index: idx
            })
            curGroup = gname;
            curContents = this.tableOfContents[this.tableOfContents.length-1];
          }
          if (curContents) {
            a.index = idx;
            const list = a.tocText.replace(/\r\n/g, "\n").replace(/\r/g, "\n").split(/\n/);
            list.forEach(l => {
              let rightContents = false;
              let isBookmarak = false;
              if (l.indexOf("【右】") >= 0) {
                rightContents = true;
                l = l.replace("【右】", "");
              }
              if (l.indexOf("★") >= 0) {
                isBookmarak = true;
                l = l.replace("★", "");
              }
              if (l) {
                const tocObj = {
                  tocText: l,
                  index: idx,
                  rightContents:rightContents
                }
                if (isBookmarak) {
                  this.bookmarks.push(tocObj);
                }
                curContents.contents.push(tocObj)
              }
            })
          }
        }
      })
      console.log(this.tableOfContents)
    },

    onLoadPage() {
      this.pageWidth = 640;
      this.pageHeight = 900;
      this.isIframeEnable = true;
      setTimeout( () => {
        this.isLoading = false;
        this.pageWidth  = this.$refs.pdfiframe.contentWindow.document.body.scrollWidth;
        this.pageHeight = this.$refs.pdfiframe.contentWindow.document.body.scrollHeight;
        this.setPageZoomAndPosition();
      }, 100);
    },

    setPageZoomAndPosition() {
      const areaInfo = this.getCurrentAreaInfo();
      const viewerSize = (window.innerWidth < this.maxViewerSize) ? window.innerWidth : this.maxViewerSize;
      this.pageZoom =  viewerSize / areaInfo.width;

      this.areaWidth  = areaInfo.width * this.pageZoom;
      this.areaHeight = areaInfo.height * this.pageZoom;
      this.pageX = -areaInfo.x * this.pageZoom;
      this.pageY = -areaInfo.y * this.pageZoom;

      history.replaceState('','',`${this.basedir}${this.dirname}/${areaInfo.page+1}-${areaInfo.subPage}/`);
    },


    onClickBefore() {
      const areas = this.getCurrentAreas();
      this.curArea = this.curArea-1;
      if (this.curArea < 0) {
        this.curArea = 0;
      }
      const areaInfo = this.getCurrentAreaInfo();

      this.loadPage(this.dirname, areaInfo.page);
    },
    onClickNext() {
      const areas = this.getCurrentAreas();
      this.curArea = this.curArea+1;
      if (this.curArea >= areas.length) {
        this.curArea = areas.length-1;
      }
      const areaInfo = this.getCurrentAreaInfo();

      this.loadPage(this.dirname, areaInfo.page);
    },

    getCurrentAreaInfo() {
      let areaInfo = null;
      if (this.spAreas && this.pcAreas) {
        if (this.viewerMode == 'sp') {
          areaInfo = this.spAreas[this.curArea];
        } else {
          areaInfo = this.pcAreas[this.curArea];
        }
      }
      return areaInfo;
    },

    getCurrentAreas() {
      let areas = null;
      if (this.spAreas && this.pcAreas) {
        if (this.viewerMode == 'sp') {
          areas = this.spAreas;
        } else {
          areas = this.pcAreas;
        }
      }
      return areas;
    },

    onChangeSlider() {
      this.loadPage(this.dirname, this.getCurrentAreaInfo().page);
    },

    onClickZoomIn() {
      this.uiZoomLevel ++;
      if (this.uiZoomLevel > 5) {
        this.uiZoomLevel = 5;
      } else {
        this.pageZoom += 0.1;
      }
      const areaInfo = this.getCurrentAreaInfo();
      this.areaWidth  = areaInfo.width * this.pageZoom;
      this.areaHeight = areaInfo.height * this.pageZoom;
      this.pageX = -areaInfo.x * this.pageZoom;
      this.pageY = -areaInfo.y * this.pageZoom;
    },

    onClickZoomOut() {
      this.uiZoomLevel --;
      if (this.uiZoomLevel < 0) {
        this.uiZoomLevel = 0;
      } else {
        this.pageZoom -= 0.1;
      }
      const areaInfo = this.getCurrentAreaInfo();
      this.areaWidth  = areaInfo.width * this.pageZoom;
      this.areaHeight = areaInfo.height * this.pageZoom;
      this.pageX = -areaInfo.x * this.pageZoom;
      this.pageY = -areaInfo.y * this.pageZoom;
    },

    onClickTOCGroup(item) {
      if (this.viewerMode == "PC") {
        this.curArea = item.index;
        this.loadPage(this.dirname, item.page)
        this.isMenuOpen = false;  
      } else {
        console.log(item);
        const page = this.pcAreas[item.index].page;
        let hit = -1;
        this.spAreas.forEach( (a, idx) => {
          if (a.page == page && hit == -1) {
            hit = idx
          }
        })
        
        if (hit >= 0) {
          this.curArea = hit;
          this.loadPage(this.dirname, page)
          this.isMenuOpen = false;
        }
      }
    },

    onClickTOC(item) {
      if (this.viewerMode == "PC") {
        this.curArea = item.index;
        this.loadPage(this.dirname, item.page)
        this.isMenuOpen = false;  
      } else {
        console.log(item);
        const page = this.pcAreas[item.index].page;
        let hit = -1;
        this.spAreas.forEach( (a, idx) => {
          if (a.page == page && hit == -1) {
            hit = idx
          }
        })
        if (item.rightContents) {
          hit++;
        }
        
        if (hit >= 0) {
          this.curArea = hit;
          this.loadPage(this.dirname, page)
          this.isMenuOpen = false;
        }
      }
    },

    getCurrentDispPage() {
      if (this.isIframeEnable) {
        if (this.viewerMode == 'sp') {

          const page = this.getCurrentAreaInfo().page;

          let findAreaIdx = -1;
          this.pcAreas.forEach( (p,idx) => {
            if (p.page == page) {
              findAreaIdx = idx;
            }
          })
          return findAreaIdx + 1;

        } else {
          return this.curArea + 1;
        }

      } else {
        return "";
      }

    },

    accordionToggle: function () {
      this.isAcOpened = !this.isAcOpened;
    },
    beforeEnter: function (el) {
      el.style.height = '0';
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function (el) {
      el.style.height = '0';
    }
  }
})
